<template>
  <v-menu
    translate="slide-y"
    elevation="4"
    offset-y
    :key="$vuetify.breakpoint.mdAndDown"
    :left="!$vuetify.breakpoint.mdAndDown"
    :right="$vuetify.breakpoint.mdAndDown"
    icon
    :open-on-hover="!$vuetify.breakpoint.mdAndDown"
    close-delay="300"
    nudge-bottom="16px"
    min-width="220px"
    v-model="adminDropdownOpen"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        large
        rounded
        class="admin-area-btn ml-2"
        :class="$vuetify.breakpoint.mdAndDown ? 'admin-area-btn-sm' : ''"
        outlined
        elevation="0"
        color=""
        :href="!$vuetify.breakpoint.mdAndDown ? adminAppUrl : null"
        target="_blank"
      >
        <v-badge :value="hasBadge" dot :color="'red'">
          <v-icon>$settings3</v-icon>
        </v-badge>
        <v-expand-x-transition>
          <span
            class="admin-area-btn-text pl-2 p-sm"
            v-show="adminDropdownOpen && !$vuetify.breakpoint.mdAndDown"
            >{{ $t("appSingleServer.adminAreaDropdown.goTo") }}</span
          >
        </v-expand-x-transition>
      </v-btn>
    </template>
    <v-list class="admin-area-dropdown dropdown-left v-list--small">
      <v-list-item
        class="p-sm"
        v-if="$vuetify.breakpoint.mdAndDown"
        :href="adminAppUrl"
        target="_blank"
      >
        <v-list-item-title>
          {{ $t("appSingleServer.adminAreaDropdown.goTo") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="admin-area-dropdown-shortcuts">
        <v-list-item-title>
          <span class="p-xs">{{
            $t("appSingleServer.adminAreaDropdown.shortcuts")
          }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        class="p-sm"
        :href="adminAppUrl + '/migrations'"
        target="_blank"
      >
        <v-badge v-if="hasUncompletedImports" dot inline left :color="'red'">
          <v-list-item-title>
            {{ $t("appSingleServer.adminAreaDropdown.migrations") }}
          </v-list-item-title>
        </v-badge>
        <v-list-item-title v-else>
          {{ $t("appSingleServer.adminAreaDropdown.migrations") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="p-sm" :href="adminAppUrl + '/logs'" target="_blank">
        <v-badge v-if="hasRunningTasks" dot inline left :color="'red'">
          <v-list-item-title>
            {{ $t("appSingleServer.adminAreaDropdown.logs") }}
          </v-list-item-title>
        </v-badge>
        <v-list-item-title v-else>
          {{ $t("appSingleServer.adminAreaDropdown.logs") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        class="p-sm"
        :href="adminAppUrl + '/configuration'"
        target="_blank"
      >
        <v-list-item-title>
          {{ $t("appSingleServer.adminAreaDropdown.configuration") }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// import Api from "@/apis/Api";
import StyleManagerMixin from "../../mixins/StyleManagerMixin";

export default {
  components: {},
  mixins: [StyleManagerMixin],
  data: function () {
    return {
      adminDropdownOpen: false,
    };
  },
  computed: {
    isAppSingleServer() {
      return !!this.$store.state.home.app.single_server?.active;
    },
    isUserSingleServerAdmin() {
      return (
        this.isAppSingleServer && !!this.$store.state.home.user?.is_ss_default
      );
    },
    adminAppUrl() {
      if (!this.isUserSingleServerAdmin) {
        return null;
      }
      return this.$store.state.home.admin?.app_url;
    },
    hasRunningTasks() {
      return !!this.$store.state.home.app.single_server?.has_running_tasks;
    },
    hasUncompletedImports() {
      return !!this.$store.state.home.app.single_server
        ?.has_uncompleted_imports;
    },
    hasBadge() {
      return this.hasRunningTasks || this.hasUncompletedImports;
    },
  },
  props: {},
};
</script>

<style lang="scss" scoped>
.admin-area {
  &-btn {
    &.v-btn.v-btn--outlined {
      height: 48px;
      min-width: 48px;
      color: var(--v-sand-darken2);
      border-color: var(--v-sand-darken2) !important;
      background-color: rgba(255, 205, 81, 0.15) !important;
      &:hover {
        border-color: var(--v-sand-darken2) !important;
      }
      &.admin-area-btn-sm {
        height: 40px;
        min-width: 40px;
        max-width: 40px;
      }
    }
    &-text {
      color: var(--v-sand-darken2);
      white-space: nowrap;
    }
    .v-icon {
      color: var(--v-sand-darken2);
      margin-right: 0;
    }
  }
  &-dropdown {
    &-shortcuts {
      min-height: 22px !important;
      pointer-events: none;
      span {
        color: var(--v-gray-lighten1);
      }
    }
  }
}
.v-btn::v-deep {
  .v-icon {
    svg {
      transition: color 0.24s ease;
    }
  }
  &:hover {
  }
}
.v-icon::v-deep {
  .v-icon__component {
    width: 18px;
    height: 18px;
  }
}
</style>
